"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEAVR_DELIVERY_ADDRESS_MAX_LENGTH = exports.WEAVR_OWT_DESCRIPTION_MAX_LENGTH = exports.WEAVR_NAME_ON_CARD_REGEX = exports.WEAVR_NAME_ON_CARD_MAX_LENGTH = exports.WEAVR_FIRST_AND_LAST_NAME_MAX_LENGTH = void 0;
/**
 * Specified by weavr
 *
 * @see https://weavr-multi-api.redoc.ly/3.58.0/tag/Authorised-Users#operation/userCreate!path=name&t=request
 */
exports.WEAVR_FIRST_AND_LAST_NAME_MAX_LENGTH = 50;
/**
 * Specified by weavr
 *
 * Weavr allows 27 here, but we're using only 20 anyway to make sure the name doesn't overlap with the Mastercard logo.
 *
 * @see https://weavr-multi-api.redoc.ly/3.58.0/tag/Managed-Cards#operation/managedCardCreate!path=0/nameOnCard&t=request
 */
exports.WEAVR_NAME_ON_CARD_MAX_LENGTH = 20;
/**
 * Specified by weavr
 *
 * @see https://weavr-multi-api.redoc.ly/3.58.0/tag/Managed-Cards#operation/managedCardCreate!path=0/nameOnCard&t=request
 */
exports.WEAVR_NAME_ON_CARD_REGEX = /^[a-zA-Z0-9ßÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÒÓÔÕÖØŠÙÚÛÜŸÝĄĆČĎĘĹĽŁŃŇÑŐŔŚȘȚŤŰŹŻŽàáâãäåæçèéêëìíîïòóôõöøšùúûüÿýąćčďęĺľłńňñőŕśșțťűźżž\-^. '-]*$/;
/**
 * Specified by weavr
 *
 * These details are passed to the beneficiary as the reference . This field is mandatory for wire transfers executed over SEPA. The allowed length is dependent on the payment type:
 *
 * SEPA <= 35 characters. An extended character set is accepted to cater for all European languages. If SEPA does not support a particular character, it is automatically converted to an acceptable alternative, in line with SEPA scheme guidance.
 *
 * Faster Payments <= 18 characters
 *
 * @see https://weavr-multi-api.redoc.ly/3.60.0/tag/Outgoing-Wire-Transfers#operation/outgoingWireTransferCreate
 */
exports.WEAVR_OWT_DESCRIPTION_MAX_LENGTH = 18;
exports.WEAVR_DELIVERY_ADDRESS_MAX_LENGTH = 50;
